<div class="header-bar">
  <h1>Incidents</h1>
</div>
<div class="content-container">
  <incidents-statistics></incidents-statistics>
</div>
<p-tabView [(activeIndex)]="stateService.currentTab" class="tab-padding">
  <p-tabPanel header="Opened">
    <job-incidents-grid
      #openedGrid
      [opened]="true"
      (onRefreshAllRequest)="closedGrid.search()"
    ></job-incidents-grid>
  </p-tabPanel>

  <p-tabPanel header="Closed">
    <job-incidents-grid
      #closedGrid
      [opened]="false"
      (onRefreshAllRequest)="openedGrid.search()"
    ></job-incidents-grid>
  </p-tabPanel>
</p-tabView>
